import {useNavigate} from 'react-router'
import {preloadResources} from 'preload'
import {Button} from 'brand/Button'
import {Logotype} from 'brand/Logotype'

export const GetStarted = () => {
  preloadResources.getStarted()
  const nav = useNavigate()
  return (
    <div className="fullscreen-bg get-started">
      <div className="column fullscreen-avoiding-chrome">
        <section>
          <div className="full-width-heading">Personalised beauty advice</div>
        </section>
        <section className="app-setup logotype">
          <Logotype align="start" />
        </section>
        <section className="app-setup">
          <div className="size-ml line-l">
            Your personalised makeup companion.
            Match makeup to your outfits, explore tutorials,
            and save your favourite looks.
          </div>
        </section>
        <section className="app-setup">
          <Button size="large" action={() => nav('/app-setup/intro')}>
            Let's get started
          </Button>
        </section>
        <section className="app-setup" style={{justifyContent: 'center'}}>
          {/* <div>Already have an account? Sign in</div> */}
        </section>
      </div>
    </div>
  )
}
